export const monthLabel = (month: number) => {
  const value = String(month);
  if (value.length !== 6) return String(month);

  const year = value.slice(0, 4);
  const monthIndex = Number(value.slice(4, 6)) - 1;
  const names = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  return `${names[monthIndex] || value.slice(4, 6)} ${year}`;
};

export const inputDateToUnix = (value: string) =>
  Math.floor(new Date(`${value}T00:00:00`).getTime() / 1000);
